export default __webpack_public_path__ + "static/media/totalFlujoNetoEfectivo.3b2336a5.svg";